import { LightningLookback } from './LightningLayer.types';

export const SOURCE_LAYER = 'lightning';
export const SOURCE_ID = 'lightning';
export const REFRESH_INTERVAL_SECONDS = 180; // 3 minutes

// Heatmap
export const HEATMAP_LAYER_ID = 'lightning-heatmap';
export const HEATMAP_MIN_ZOOM = 3;
export const HEATMAP_MAX_ZOOM = 8;

// Items
export const ITEM_ICON_LAYER_ID = 'lightning-item-icon';
export const ITEM_MIN_ZOOM = 6;
export const ITEM_MAX_ZOOM_PUBLIC_USER = 15;

// Zoom threshold at which strike counts become visible in the tools card.
export const COUNTS_MIN_ZOOM = 7;

// Selected
export const ITEM_SELECTED_LAYER_ID = 'lightning-item-selected';
export const SELECTED_PULSE_BASE_RADIUS = 3;

// Trailing window (seconds) of strikes shown per radar timeline frame
export const RADAR_TIMELINE_WINDOW_SEC = 5 * 60;

// Trailing window (seconds) of strikes shown per lightning timeline frame
export const LIGHTNING_TIMELINE_WINDOW_SEC = 60 * 60;

// Lightning timeline playback
export const LIGHTNING_TIMELINE_STEP_MIN = 30;
export const LIGHTNING_TIMELINE_FPS = 10;

export const LIGHTNING_LOOKBACK_OPTIONS: readonly LightningLookback[] = [
  { key: '90m', minAge: 0, maxAge: 90, minZoom: 3 },
  { key: '3h', minAge: 90, maxAge: 180, minZoom: 3 },
  { key: '6h', minAge: 180, maxAge: 360, minZoom: 3 },
  { key: '12h', minAge: 360, maxAge: 720, minZoom: 5 },
  { key: '24h', minAge: 720, maxAge: 1440, minZoom: 5 },
  { key: '48h', minAge: 1440, maxAge: 2880, minZoom: 7 },
  { key: '72h', minAge: 2880, maxAge: 4320, minZoom: 7 },
];

export const DEFAULT_LIGHTNING_LOOKBACK = LIGHTNING_LOOKBACK_OPTIONS[0];
